import { Link } from 'react-router-dom';
import ComingSoon from '../../components/admin/ComingSoon';

/**
 * There's no real payments/payouts endpoint on this backend yet — this
 * page previously ran entirely on mock data (fake references, interest
 * rates, bank payouts) across three different mock API slices. Converted
 * to the same Coming Soon treatment as the rest of the not-yet-built areas
 * rather than showing investors numbers that don't correspond to anything
 * real. Real investment data (principal, funding, status) is already live
 * on My Investments.
 */
export default function Statements() {
  return (
    <div className="space-y-3">
      <ComingSoon title="Statements" backTo="/dashboard" />
      <p className="text-center text-sm text-foreground-muted -mt-6">
        In the meantime, see <Link to="/my-investments" className="text-accent hover:underline">My Investments</Link> for your real investment data.
      </p>
    </div>
  );
}
